export default {
	'bom-diagnosis': {
		id: 'bom-diagnosis',
		label: 'BOM成本卡诊断',
		code: '0006_0001'
	}
}
